<template>
  <el-table :data="data" :stripe="true" :model="model" :show-header="false">
    <el-table-column>
      <template slot-scope="scope">
        <div class="name">
          {{ scope.row.name }}
        </div>
        <div class="description" v-if="scope.row.description">
          {{ scope.row.description }}
        </div>
      </template>
    </el-table-column>
    <el-table-column width="100" align="right">
      <template slot-scope="scope">
        <el-switch v-model="model[scope.row.code]" :disabled="disabled" />
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  name: 'ToggleList',
  props: {
    model: {
      type: Object,
      default: {}
    },

    data: {
      type: Array,
      default: function() {
        return []
      }
    },

    disabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.description {
  font-size: 12px;
  color: #7e8596;
}
</style>



// WEBPACK FOOTER //
// src/common/components/form/ToggleList.vue